export default __webpack_public_path__ + "static/media/delete.967a3688.svg";